export default __webpack_public_path__ + "static/media/close-black.007ab5eb.svg";